import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

// i18n
//   .use(HttpBackend)
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     fallbackLng: "ar",
//     lng: "ar",
//     supportedLngs: ["en", "ar"],
//     ns: ["common"],
//     defaultNS: "common",
//     backend: {
//       loadPath: "/locales/{{lng}}/{{ns}}.json",
//     },
//     detection: {
//       order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
//       lookupQuerystring: "lng",
//       lookupCookie: "i18next",
//       lookupLocalStorage: "i18nextLng",
//       caches: ["cookie", "localStorage"],
//       cookieMinutes: 365 * 24 * 60,
//     },
//     interpolation: {
//       escapeValue: false,
//     },
//     react: {
//       useSuspense: true,
//     },
//   });

// // i18
// const html = document.documentElement;
// i18n.on("languageChanged", (lng) => {
//   html.setAttribute("lang", lng);
//   html.setAttribute("dir", lng === "ar" ? "rtl" : "ltr");
// });

// const initialLng = i18n.language || "ar";
// html.setAttribute("lang", initialLng);
// html.setAttribute("dir", initialLng === "ar" ? "rtl" : "ltr");

i18n.use(initReactI18next).init({
  lng: "ar",
  fallbackLng: "ar",
  supportedLngs: ["ar"],
  ns: ["common"],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

const html = document.documentElement;
html.setAttribute("lang", "ar");
html.setAttribute("dir", "rtl");

export default i18n;
